"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineStem = determineStem;

var _flattenSortLength = require("../morphoHelpers/flattenSortLength");

var _lodashEs = require("lodash-es");

var _stem = require("./stem");

var _stem2 = _interopRequireDefault(_stem);

var _stemTOrDFromEndOfWord = require("./stemTOrDFromEndOfWord");

var _exceptionListHelpers = require("../morphoHelpers/exceptionListHelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Checks if the word checked is in the list of strong verbs exceptions. If it is, only return the first stem from the stem set.
 * E.g. stems: help, hielp, geholp -> the stem returned would be "help".
 *
 * @param {Object} strongVerbsLists	The exception lists of strong verbs.
 * @param {string} stemmedWord The word to check.
 * @returns {string} The unique stem.
 */


var checkStrongVerbExceptionList = function checkStrongVerbExceptionList(strongVerbsLists, stemmedWord) {
  for (var _i = 0, _Object$keys = Object.keys(strongVerbsLists); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];

    var _iterator = _createForOfIteratorHelper(strongVerbsLists[key]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var stemsSet = _step.value;
        var stems = (0, _lodashEs.flatten)(Object.values(stemsSet));

        if (stems.includes(stemmedWord)) {
          return stems[0];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};
/**
 * Checks if the word checked is in the list of strong verbs exceptions. Before checking, see if the word has a prefix and delete it if it does.
 * If the stem after prefix deletion is in the verb exception list, only return the first stem from the stem set and attach back the prefix.
 * E.g. words to check: verhielp, stem set: help, hielp, geholp -> the stem returned would be "verhelp".
 *
 * @param  {Object} morphologyDataNL 	The Dutch morphology data file.
 * @param  {string} stemmedWord 		The word to check.
 *
 * @returns {string} The unique stem.
 */


var findStemOnVerbExceptionList = function findStemOnVerbExceptionList(morphologyDataNL, stemmedWord) {
  var prefixes = (0, _flattenSortLength.flattenSortLength)(morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes); // Check whether the inputted stem is started with one of the separable compound prefixes

  var foundPrefix = prefixes.find(function (prefix) {
    return stemmedWord.startsWith(prefix);
  });
  var doNotStemPrefix = morphologyDataNL.stemExceptions.stemmingExceptionsWithMultipleStems.strongAndIrregularVerbs.doNotStemPrefix;
  var doNotStemPrefixException = doNotStemPrefix.find(function (exception) {
    return stemmedWord.endsWith(exception);
  });
  var stemmedWordWithoutPrefix = ""; // Check whether the stemmedWord is in the list of strong verbs starting with be-, ont- or ver- that do not need to be stemmed.

  if (doNotStemPrefixException) {
    // Reset foundPrefix so that it won't be attached when the stem is found in the verb exception list.
    foundPrefix = null; // If the inputted stem is started with one of the separable compound prefixes, the prefix needs to be deleted for now.
  } else if (foundPrefix) {
    // Delete the prefix for now.
    stemmedWordWithoutPrefix = stemmedWord.slice(foundPrefix.length, stemmedWord.length); // At least 3 characters left after prefix deletion so that e.g. "be" is not found in the stem "berg".

    if (stemmedWordWithoutPrefix.length > 2) {
      stemmedWord = stemmedWordWithoutPrefix;
    } else {
      // Reset foundPrefix so that it won't be attached when the stem is found in the verb exception list.
      foundPrefix = null;
    }
  }

  var strongVerbExceptions = morphologyDataNL.stemExceptions.stemmingExceptionsWithMultipleStems.strongAndIrregularVerbs.strongVerbStems; // Find stem strong verbs lists.

  var strongVerbsExceptionLists = [strongVerbExceptions.irregularStrongVerbs, strongVerbExceptions.regularStrongVerbs, strongVerbExceptions.bothRegularAndIrregularStrongVerbs];

  for (var i = 0; i < strongVerbsExceptionLists.length; i++) {
    var checkIfWordIsException = checkStrongVerbExceptionList(strongVerbsExceptionLists[i], stemmedWord);

    if (checkIfWordIsException) {
      // If the word checked had a prefix previously, attach it back.
      if (foundPrefix) {
        return foundPrefix + checkStrongVerbExceptionList(strongVerbsExceptionLists[i], stemmedWord);
      } // If the word checked did not have a prefix previously, only return the first stem.


      return checkStrongVerbExceptionList(strongVerbsExceptionLists[i], stemmedWord);
    }
  }
};
/**
 * Return the unique stem for a given Dutch input word.
 *
 * @param {string} word The word to be checked.
 * @param {Object} morphologyDataNL The Dutch data file.
 *
 * @returns {string} The unique stem.
 */


function determineStem(word, morphologyDataNL) {
  var stemmedWord = (0, _stem2.default)(word, morphologyDataNL); // Check whether the stemmed word is on an exception list of words with multiple stems. If it is, return the canonical stem.

  var stemFromExceptionList = (0, _exceptionListHelpers.checkExceptionListWithTwoStems)(morphologyDataNL.stemExceptions.stemmingExceptionsWithMultipleStems.stemmingExceptionsWithTwoStems, stemmedWord);

  if (stemFromExceptionList) {
    return stemFromExceptionList;
  }

  stemFromExceptionList = findStemOnVerbExceptionList(morphologyDataNL, stemmedWord);

  if (stemFromExceptionList) {
    return stemFromExceptionList;
  } // If the stemmed word ends in -t or -d, check whether it should be stemmed further, and return the stem with or without the -t/d.


  var ambiguousEndings = morphologyDataNL.ambiguousTAndDEndings.tAndDEndings;

  var _iterator2 = _createForOfIteratorHelper(ambiguousEndings),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var ending = _step2.value;

      if (stemmedWord.endsWith(ending)) {
        var stemmedWordWithoutTOrD = (0, _stemTOrDFromEndOfWord.stemTOrDFromEndOfWord)(morphologyDataNL, stemmedWord, word);

        if (stemmedWordWithoutTOrD) {
          return stemmedWordWithoutTOrD;
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return stemmedWord;
}